/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Rating } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import React from "react";

const ReviewsList = () => {

  const navigate = useNavigate();
  const [value, setValue] = React.useState<number | null>(4);

  const rows = [
    {
      id: 1,
      name: "Plumber",
      date: "01 March 2025"
    },
    {
      id: 2,
      name: "Electrician",
      date: "01 March 2025"
    },
    {
      id: 3,
      name: "HVAC",
      date: "01 March 2025"
    },
    {
      id: 4,
      name: "Carpenter",
      date: "01 March 2025"
    },
    {
      id: 5,
      name: "Cleaning",
      date: "01 March 2025"
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 220,
      field: "customer",
      headerName: "Customer Detail",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block click_action" onClick={() => navigate('/manage-customers/detail')}>
            <figure>
              <img src="/static/images/user_placeholder.png" alt="" />
            </figure>
            <p><b>Madelyn Dias</b> <span>madelyndias@gmail.com</span></p>
          </div>
        )
      }
    },
    {
      flex: 1,
      minWidth: 220,
      field: "maintenance",
      headerName: "Maintenance Team Detail",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block click_action" onClick={() => navigate('/manage-maintenance-team/detail')}>
            <figure className="no_radius">
              <img src="/static/images/placeholder.png" alt="" />
            </figure>
            <p><b>Maintenance Team 1</b> <span>maintenance@gmail.com</span></p>
          </div>
        )
      }
    },
    {
      minWidth: 160,
      field: "rating",
      headerName: "Rating",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <Rating name="read-only" value={value} readOnly className="v2" />
        )
      }
    },
    {
      flex: 2,
      minWidth: 200,
      field: "review",
      headerName: "Review",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad a harum, autem placeat veniam alias fugiat? Fugiat itaque iste veniam nemo, provident est soluta ipsa reprehenderit esse eligendi, maxime quo dolorum obcaecati quidem labore maiores, dignissimos incidunt tempore deleniti eius.</p>
        )
      }
    },
    {
      minWidth: 150,
      field: "date",
      headerName: "Date",
      editable: false,
      sortable: false,
    },
  ];
  let hidden = ["fullName"];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
        />
      </div>
    </>
  );
};

export default ReviewsList;
